// @flow

import * as React from 'react';
import CodeBlock from 'app/components/docs/shared/code-block';
import Heading from 'app/components/docs/shared/heading';
import Link from 'app/components/docs/shared/link';
import awsLaunchStackButtonImage from 'app/images/aws-launch-stack-button.svg';

import 'highlight.js/styles/atom-one-light.css';

type Props = {
  token?: string,
  className?: string,
  style?: Object
};

AWSQuickStart.title = 'AWS';

function AWSQuickStart(props: Props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <Heading>Install the Agent on your own AWS instance</Heading>
      <p>To run the agent on your own AWS instances use whichever installer matches your instance type. For Amazon Linux use the RH/CentOS installer.</p>

      <Heading>Use our pre-built Elastic CI Stack for AWS</Heading>
      <p>The <Link href="https://github.com/buildkite/elastic-ci-stack-for-aws">Elastic CI Stack for AWS</Link> is a pre–built CloudFormation template that gives you an autoscaling agent cluster including Docker, S3 and CloudWatch integration. <Link href="https://github.com/buildkite/elastic-ci-stack-for-aws">Read the documentation</Link> on GitHub, and launch it using the details below:</p>
      <p>
        <Link
          href="https://console.aws.amazon.com/cloudformation/home#/stacks/new?stackName=buildkite&templateURL=https://s3.amazonaws.com/buildkite-aws-stack/latest/aws-stack.yml"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={awsLaunchStackButtonImage}
            alt="Launch Buildkite Elastic CI Stack"
            width="144"
            height="27"
          />
        </Link>
      </p>

      <p>You will need your <strong>BuildkiteAgentToken</strong> when launching the stack:</p>
      <CodeBlock>
        <span className="hljs-attribute">{props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE'}</span><br />
      </CodeBlock>

      <p className="rounded bg-silver p2">
        We recommend following AWS best practice by setting up a separate development AWS account and using role switching and consolidated billing. See the AWS tutorial on <Link href="http://docs.aws.amazon.com/IAM/latest/UserGuide/tutorial_cross-account-with-roles.html">access delegation across AWS accounts</Link>, and <Link href="https://github.com/buildkite/elastic-ci-stack-for-aws">Elastic CI Stack repository on GitHub</Link> for full documentation.
      </p>
    </div>
  );
}

export default AWSQuickStart;
